import { AgentOnboardingPromptButton } from '../../../components/AgentOnboardingPromptButton';
import { WalletCta } from '../../../components/WalletCta';
import { useOptionalQuickstartKey } from '../../keys/QuickstartKeyProvider';
import { buildAgentOnboardingPrompt, HERO_CTA_BUTTON_CLASS } from '../../../lib/onboardingCta';
import { signupPhrases } from '../../../lib/signupOffer';

/**
 * The closing banner's action on the catalog, platform and endpoint pages: the
 * human signup with the offer on it, beside the split control that hands the
 * onboarding prompt to a coding agent.
 *
 * Both audiences are asked in one row rather than behind a toggle, the same
 * shape the hero uses, because a reader who scrolled a catalog page to the end
 * has already chosen which of the two they are.
 */
export const CatalogFunnelAction = () => {
  // Null on the marketing tree, where the provider never mounts, so the payload
  // here is the signed-out one.
  const quickstart = useOptionalQuickstartKey();
  const prompt = buildAgentOnboardingPrompt({
    apiKey: quickstart?.secret ?? undefined,
    signedIn: quickstart !== null,
  });
  return (
    <div className="mx-auto flex w-full flex-col gap-3 s720:grid s720:w-fit s720:grid-cols-[repeat(2,332px)]">
      <WalletCta className={HERO_CTA_BUTTON_CLASS} label={signupPhrases().HUMAN_SIGNUP_OFFER_CTA} />
      <AgentOnboardingPromptButton prompt={prompt} />
    </div>
  );
};
